import { render } from "./Masthead.vue?vue&type=template&id=68a67d62&scoped=true"
import script from "./Masthead.vue?vue&type=script&lang=js"
export * from "./Masthead.vue?vue&type=script&lang=js"

import "./Masthead.vue?vue&type=style&index=0&id=68a67d62&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a67d62"]])

export default __exports__